import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Carousel } from 'react-responsive-carousel';
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import axios from 'axios';
import { BaseUrlContext } from '../Context/BaseUrl';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

export default function Home(props) {
    const { baseUrl, imgUrl } = useContext(BaseUrlContext);
    // get courses
    let [courses, setCourses] = useState([]);
    async function getAllCourses() {

        await axios.post(`${baseUrl}/get_courses`)
            .then(response => {
                // Handle the response
                if (response.data.Ecode === 200) {
                    console.log(response.data.Edata);
                    setCourses(response.data.Edata);
                }

            })
            .catch(error => {

                // Handle any errors
                console.error(error);
            });

    }
    useEffect(() => {
        getAllCourses();
    }, [])

    // subscribe form

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const customStyles = {
        content: {
            top: '0',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            // transform: 'translate(-50%, -50%)',
        },
    };
    //  all values

    const [nameValue, setNameValue] = useState();
    const [email, setEmail] = useState();


    const [submitMsg, setSubmitMsg] = useState('');
    const [message, setMessage] = useState('');

    async function submitForm(e) {
        e.preventDefault();
        const bodyFormData = new FormData();

        bodyFormData.append('name', nameValue);
        bodyFormData.append('email', email);


        const response = await axios.post(`https://saudigermanacademy.com/Aadm25/api/mwforms/subscribtion`, bodyFormData)
            .then(response => {
                // console.log(branchValue);
                // Handle the response
                if (response.data.Ecode === 200) {
                    // setCheckPhoneNum(response.data.Emsg);
                    console.log(response.data);
                    // handleShow();
                    if (response.data.Edata.request_id > 0) {
                        setSubmitMsg('Thank You!')
                        setMessage("Your form has been submitted successfully.")
                    } else {
                        setSubmitMsg('Oppssss!! please Check Your Data ')

                    }

                    handleShow();

                }

            })
            .catch(error => {
                // Handle any errors
                console.error(error);
            });

    }



    //  contact us form

    const [name, setName] = useState();
    const [contactEmail, setContactEmail] = useState();
    const [phone, setPhone] = useState();
    const [position, setPosition] = useState();
    const [sms, setSms] = useState();
    const [organization, setOrganization] = useState();

    const [contactShow, setContactShow] = useState(false);

    const handleContactClose = () => setContactShow(false);
    const handleContactShow = () => setContactShow(true);
    const [contactMsg, setContactMsg] = useState('');
    const [contaactMessage, setContactMessage] = useState('');

    async function submitContactForm(e) {
        e.preventDefault();
        const bodyFormData = new FormData();

        bodyFormData.append('name', name);
        bodyFormData.append('contactEmail', contactEmail);
        bodyFormData.append('phone', phone);
        bodyFormData.append('position', position);
        bodyFormData.append('organization', organization);
        bodyFormData.append('sms', sms);


        const response = await axios.post(`https://saudigermanacademy.com/Aadm25/api/mwforms/contact`, bodyFormData)
            .then(response => {
                // console.log(branchValue);
                // Handle the response
                if (response.data.Ecode === 200) {
                    // setCheckPhoneNum(response.data.Emsg);
                    console.log(response.data);
                    // handleShow();
                    if (response.data.Edata.request_id > 0) {
                        setContactMsg('Thank You!')
                        setContactMessage("Your form has been submitted successfully.")
                    } else {
                        setContactMsg('Oppssss!! please Check Your Data ')

                    }

                    handleContactShow();

                }

            })
            .catch(error => {
                // Handle any errors
                console.error(error);
            });

    }
    return <>
        {/* <!-- Start main-content --> */}
        <div className="main-content-area">
            {/* <!-- Section: home --> */}
            {/* <!-- Section: home --> */}
            <section id="home">
                <div className="container-fluid p-0">
                    <div className="rev_slider_wrapper" style={{ touchAction: 'pan-y' }}>
                        <Carousel style={{ touchAction: 'pan-y' }} infiniteLoop swipeable nav={true} showThumbs={false} showStatus={false} className='d-md-block d-none' >
                            <div className='m-0' data-index="rs-1" data-transition="slidingoverlayhorizontal" data-slotamount="default" data-easein="default" data-easeout="default" data-masterspeed="default" data-rotate="0" data-saveperformance="off" data-title="Slide 1" data-description="">

                                <img src="images/bg/slider_result.webp" alt="" />
                                {/* <div className="legend start-25 ms-auto">
                                    <h1 className='title-1'>Education</h1>
                                    <h2 className='title-2'>Hospital Management Excellence</h2>
                                    <p>We provide the best services for our clients and always strive for their trust and satisfaction.</p>
                                    <Link to="" className="btn btn-colored btn-lg btn-flat btn-theme-colored border-left-theme-color-2-6px pl-20 pr-20">
                                        View Details
                                    </Link>
                                </div> */}
                            </div>
                            <div className='m-0' data-index="rs-1" data-transition="slidingoverlayhorizontal" data-slotamount="default" data-easein="default" data-easeout="default" data-masterspeed="default" data-thumb="images/bg/bg3.png" data-rotate="0" data-saveperformance="off" data-title="Slide 1" data-description="">

                                <img src="images/bg/slider2-_result.webp" alt="" />
                                <div className="legend">
                                    <h1 className='title-1'>Education</h1>
                                    <h2 className='title-2'>Hospital Management Excellence</h2>

                                </div>
                            </div>
                            <div className='m-0' data-index="rs-1" data-transition="slidingoverlayhorizontal" data-slotamount="default" data-easein="default" data-easeout="default" data-masterspeed="default" data-thumb="images/bg/bg4.png" data-rotate="0" data-saveperformance="off" data-title="Slide 1" data-description="">

                                <img src="images/bg/slider-3_result.webp" alt="" />
                                <div className="legend me-auto">
                                    <h1 className='title-1'>Education</h1>
                                    <h2 className='title-2'>Hospital Management Excellence</h2>
                                    {/* <p>We provide the best services for our clients and always strive for their trust and satisfaction.</p> */}
                                    {/* <Link to="" className="btn btn-colored btn-lg btn-flat btn-theme-colored border-left-theme-color-2-6px pl-20 pr-20">
                                        View Details
                                    </Link> */}
                                </div>
                            </div>
                            {/* Add more slides here */}
                        </Carousel>
                        <Carousel infiniteLoop style={{ touchAction: 'pan-y' }}
                            swipeable
                            showThumbs={false}
                            showStatus={false}
                            className='d-md-none d-block'>
                            <div className='m-0' >

                                <img src="images/mobile-version/slider-copy_result.webp" alt="" />

                            </div>
                            <div className='m-0' >

                                <img src="images/mobile-version/slider-2_result.webp" alt="" />
                                <div className="legend m-auto">
                                    <h1 className='title-1'>Education</h1>
                                    <h2 className='title-2'>Hospital Management Excellence</h2>

                                </div>
                            </div>
                            <div className='m-0'>

                                <img src="images/mobile-version/slider-3_result.webp" alt="" />
                                <div className="legend  m-auto">
                                    <h1 className='title-1'>Education</h1>
                                    <h2 className='title-2'>Hospital Management Excellence</h2>
                                    {/* <p>We provide the best services for our clients and always strive for their trust and satisfaction.</p> */}
                                    {/* <Link to="" className="btn btn-colored btn-lg btn-flat btn-theme-colored border-left-theme-color-2-6px pl-20 pr-20">
                                        View Details
                                    </Link> */}
                                </div>
                            </div>
                            {/* Add more slides here */}
                        </Carousel>
                    </div>
                </div>
            </section>


            {/* <!-- Section: About --> */}
            <section className='bg-silver-light'>
                <div className="container pt-5">
                    <div className="section-content">
                        <div className="row align-items-center">
                            <div className="col-sm-12 col-md-12 col-lg-8 col-xl-8">
                                <h3 className="text-uppercase font-weight-800 mt-0 mb-0 line-height-1 text-theme-colored2">Saudi German Academy</h3>
                                <h6 className="text-uppercase line-bottom line-bottom-theme-colored1 title font-playfair text-uppercase"> Welcome to Education</h6>
                                <p className="">The Saudi German Academy recognizes the importance of investing in the education and training of hospital management
                                    professionals for the advancement of our healthcare systems. By equipping future leaders, we aim to guarantee that hospitals can
                                    sustain their provision of top-notch patient care and stay at the forefront of medical research and innovation.<br />
                                    The Saudi German Academy is the pioneering and most inventive hospital management academy devoted to shaping the future of
                                    hospital management. We play an essential role in training tomorrow’s hospital leaders to tackle the most arduous challenges.</p>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="tm-sc-icon-box icon-box icon-left tm-iconbox-icontype-font-icon text-left iconbox-centered-in-responsive iconbox-theme-colored1 icon-position-icon-left mb-30">
                                            <div className="icon-box-wrapper">
                                                <Link className="icon icon-type-font-icon icon-circled icon-sm icon-dark icon-theme-colored1 mt-10">
                                                    <i className="flaticon-medical-ambulance14"></i></Link>
                                                <div className="icon-text">
                                                    <h5 className="icon-box-title text-uppercase mb-10">Our Vision</h5>
                                                    <p className="mb-0">Empowering professionals to achieve hospital excellence.</p>
                                                </div>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="tm-sc-icon-box icon-box icon-left tm-iconbox-icontype-font-icon text-left iconbox-centered-in-responsive iconbox-theme-colored1 icon-position-icon-left mb-30">
                                            <div className="icon-box-wrapper">
                                                <Link className="icon icon-type-font-icon icon-circled icon-sm icon-dark icon-theme-colored1 mt-10">
                                                    <i className="flaticon-medical-ambulance14"></i></Link>
                                                <div className="icon-text">
                                                    <h5 className="icon-box-title text-uppercase mb-10">Our Values</h5>
                                                    <p className="mb-0">Authenticity – Community – Influence – Honesty – Creativity - Growth</p>
                                                </div>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="tm-sc-icon-box icon-box icon-left tm-iconbox-icontype-font-icon text-left iconbox-centered-in-responsive iconbox-theme-colored1 icon-position-icon-left mb-30">
                                            <div className="icon-box-wrapper">
                                                <Link className="icon icon-type-font-icon icon-circled icon-sm icon-dark icon-theme-colored1 mt-10">
                                                    <i className="flaticon-medical-ambulance14"></i></Link>
                                                <div className="icon-text">
                                                    <h5 className="icon-box-title text-uppercase mb-10">Our Mission</h5>
                                                    <p className="mb-0">Saudi German Academy, is the hub of professional training and education solutions in the field of hospital management aiming for
                                                        efficient operation and effective outcomes.</p>
                                                </div>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                                <form className="booking-form form-home bg-theme-colored2 p-30" onSubmit={submitContactForm}>
                                    <h3 className="text-white mt-0 mb-20">Contact <span className="text-theme-colored1">Us </span></h3>
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="mb-3 mb-10">
                                                <input name="name" className="form-control" type="text" required="" placeholder="Enter Name" aria-required="true" value={name} onChange={(e) => setName(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="mb-3 mb-10">
                                                <input name="contactEmail" className="form-control required email" type="email" placeholder="Enter Email" aria-required="true" value={contactEmail} onChange={(e) => setContactEmail(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="mb-3 mb-10">
                                                <input name="Phone" className="form-control required" type="number" placeholder="Enter Phone" aria-required="true" value={phone} onChange={(e) => setPhone(e.target.value)} />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="mb-3 mb-20">
                                                <input name="Position" className="form-control required date-picker" type="text" placeholder="Position" aria-required="true" value={position} onChange={(e) => setPosition(e.target.value)} />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="mb-3 mb-10">
                                                <input name="Organization" className="form-control required date-picker" type="text" placeholder="Organization" aria-required="true" value={organization} onChange={(e) => setOrganization(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-3 mb-10">
                                        <textarea name="sms" className="form-control required" placeholder="Enter Message" rows="3" aria-required="true" Value={sms} onChange={(e) => setSms(e.target.value)}></textarea>
                                    </div>
                                    <div className="mb-3 mb-0 mt-20">
                                        {/* <input name="form_botcheck" className="form-control" type="hidden" value="" /> */}
                                        <button type="submit" className="btn btn-theme-colored1 btn-block" data-loading-text="Please wait...">Submit Request</button>
                                    </div>
                                </form>
                                <div className="col-sm-12 text-center">

                                    <Modal   {...props}
                                        size="lg"
                                        style={customStyles}
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered show={contactShow} onHide={handleContactClose} className="top-0 ">

                                        <Modal.Header closeButton>
                                            <img className="" src='/images/cropped-9952-img-32x32.jpg' alt="" />

                                            <Modal.Title className='text-theme-colored2 fw-bold'>Contact Us</Modal.Title>
                                        </Modal.Header>

                                        <Modal.Body>
                                            <div className="team-member text-center">
                                                <div className="team-description pt-0">
                                                    <h3><Link>{contactMsg}</Link></h3>
                                                    <p className='lead fw-light'>{contaactMessage}</p>
                                                </div>



                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <Button className='btn btn-theme-colored2 btn-sm appoint-btn mt-3 mt-sm-0' variant="secondary" onClick={handleContactClose}>
                                                Close
                                            </Button>

                                        </Modal.Footer>

                                    </Modal>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- Section: Funfacts --> */}
            <section className="layer-overlay overlay-theme-colored2-9 bg-no-repeat bg-pos-center-center" data-tm-bg-img="images/bg/bg2.jpg" style={{ backgroundImage: `url('images/bg/bg2.jpg')` }}>
                <div className="container pt-0 pb-50">
                    <div className="section-content">
                        <div className="container pt-5">
                            <div className="row">
                                <VisibilitySensor partialVisibility>

                                    {({ isVisible }) => <>
                                        <div className="col-md-6 col-lg-3 col-xl-3">
                                            <div className="funfact-item text-center mb-md-60">
                                                <i className="funfact-icon pe-7s-smile text-theme-colored2"></i>
                                                {isVisible ?
                                                    <h2 data-animation-duration="2000" data-value="5248" className="text-white counter animate-number mt-0 mb-10"> +<CountUp end={5} />K</h2> : ''}
                                                <p className="text-white title mb-0">Participants</p>
                                            </div>
                                        </div>
                                    </>}
                                </VisibilitySensor>
                                <VisibilitySensor partialVisibility>

                                    {({ isVisible }) => <>
                                        <div className="col-md-6 col-lg-3 col-xl-3">
                                            <div className="funfact-item text-center mb-md-60">
                                                <i className="funfact-icon pe-7s-note2 text-theme-colored2"></i>
                                                {isVisible ?
                                                    <h2 data-animation-duration="2000" data-value="645" className="text-white counter animate-number mt-0 mb-10"><CountUp end={50} />+</h2> : ''}
                                                <p className="text-white title mb-0">Our Courses</p>
                                            </div>
                                        </div>
                                    </>}
                                </VisibilitySensor>
                                <VisibilitySensor partialVisibility>

                                    {({ isVisible }) => <>
                                        <div className="col-md-6 col-lg-3 col-xl-3">
                                            <div className="funfact-item text-center mb-sm-60">
                                                <i className="funfact-icon pe-7s-users text-theme-colored2"></i>
                                                {isVisible ?
                                                    <h2 data-animation-duration="2000" data-value="248" className="text-white counter animate-number mt-0 mb-10"><CountUp end={10} />+</h2> : ''}
                                                <p className="text-white title mb-0">Scientific events per year
                                                </p>
                                            </div>
                                        </div>
                                    </>}
                                </VisibilitySensor>
                                <VisibilitySensor partialVisibility>

                                    {({ isVisible }) => <>
                                        <div className="col-md-6 col-lg-3 col-xl-3">
                                            <div className="funfact-item text-center">
                                                <i className="funfact-icon pe-7s-cup text-theme-colored2"></i>
                                                {isVisible ?
                                                    <h2 data-animation-duration="2000" data-value="24" className="text-white counter animate-number mt-0 mb-10"><CountUp end={200} />+</h2> : ''}
                                                <p className="text-white title mb-0">Rounds</p>
                                            </div>
                                        </div>

                                    </>}
                                </VisibilitySensor>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            {/* <!-- Section: events --> */}
            <section className="bg-silver-light">
                <div className="container pt-5">
                    <div className="section-title">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="mb-60">
                                    <div className="tm-sc tm-sc-section-title section-title">
                                        <div className="title-wrapper">
                                            <h3 className="text-uppercase font-weight-800 mt-0 mb-0 line-height-1 text-theme-colored2">Upcomming Courses</h3>
                                            <h6 className="text-uppercase line-bottom line-bottom-theme-colored1 title font-playfair text-uppercase"></h6>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section-content">
                        <div className="row">
                            <OwlCarousel

                                items={6}
                                margin={10}
                                loop
                                autoplay
                                nav={false}
                                dots={true}
                                responsive={{
                                    0: { items: 1 },
                                    768: { items: 4 },
                                    1024: { items: 3 },
                                }}
                            >
                                {courses.map((course, index) => <>
                                    <div className="item" key={index}>
                                        {/* <div className="col-sm-12 col-md-6 col-lg-4 col-xl-4"> */}
                                        <div className="tm-sc tm-sc-blog tm-sc-blog-masonry blog-style1-current-theme mb-lg-30">
                                            <article className="post">
                                                <div className="entry-header">
                                                    <div className="post-thumb">
                                                        <div className="post-thumb-inner">
                                                            <div className="thumb"> <img className="w-100" src={`${imgUrl}${course.image}`} alt={course.name} /></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="entry-content">
                                                    <div className="clearfix mb-15">
                                                        <div className="entry-date media-left text-center">
                                                            <ul>
                                                                <li className="font-16 text-white font-weight-600 border-bottom">{new Date(course.start_date).getDate()}</li>
                                                                <li className="font-12 text-white text-uppercase">{new Date(course.start_date).toLocaleString('default', { month: 'short' })}</li>
                                                            </ul>
                                                        </div>
                                                        <div className="overflow-hidden">
                                                            <h5 className="entry-title"><Link to="#" rel="bookmark">{course.name}</Link></h5>
                                                            <div className="blog-meta">
                                                                <span className="admin-type mr-10">
                                                                    <i class="fa fa-regular fa-clock text-theme-colored1 me-2"></i>

                                                                    {course.Hours} Hours
                                                                </span>
                                                                <span className="comments-type">
                                                                    <i class="fa fa-object-ungroup text-theme-colored1 me-2"></i>
                                                                    {course.sessions_per_month} Sessions
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <p className="mb-15">{(course.description).split(' ').slice(0, 30).join(' ')}</p>
                                                    <Link to="#" target="_self" className="btn-plain-text-with-arrow"> Read More </Link>
                                                    <div className="clearfix"></div>
                                                </div>
                                            </article>
                                        </div>
                                        {/* </div> */}
                                    </div>
                                </>)}

                            </OwlCarousel>
                        </div>
                    </div>
                </div>
            </section>




            {/* <!-- Section: Staff --> */}
            {/* <section>
                <div className="container">
                    <div className="section-title">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="mb-60">
                                    <div className="tm-sc tm-sc-section-title section-title">
                                        <div className="title-wrapper">
                                            <h2 className="text-uppercase line-bottom line-bottom-theme-colored1">Our <span className="text-theme-colored1">Teachers</span></h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section-content">
                        <div className="row">
                            <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3">
                                <div className="staff-item mb-lg-40">
                                    <div className="staff-thumb"> <img alt="img" src="images/team/team5.jpg" className="w-100" />
                                    </div>
                                    <div className="staff-content">
                                        <h4 className="staff-name text-theme-colored1 mt-0">Andre Smith - <small>Teacher</small></h4>
                                        <p className="mb-20">Lorem ipsum dolor sit amet, con amit sectetur adipisicing elit.</p>
                                        <div className="staff-social-part">
                                            <ul className="styled-icons icon-dark icon-theme-colored2 icon-sm icon-circled float-start mt-10">
                                                <li><Link className="social-link" to="#"><i className="fab fa-facebook"></i></Link></li>
                                                <li><Link className="social-link" to="#"><i className="fab fa-twitter"></i></Link></li>
                                                <li><Link className="social-link" to="#"><i className="fab fa-youtube"></i></Link></li>
                                            </ul>
                                            <Link className="btn btn-theme-colored2 btn-xs p-10 float-end" to="#">view details</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3">
                                <div className="staff-item mb-lg-40">
                                    <div className="staff-thumb"> <img alt="img" src="images/team/team6.jpg" className="w-100" />
                                    </div>
                                    <div className="staff-content">
                                        <h4 className="staff-name text-theme-colored1 mt-0">Andre Smith - <small>Teacher</small></h4>
                                        <p className="mb-20">Lorem ipsum dolor sit amet, con amit sectetur adipisicing elit.</p>
                                        <div className="staff-social-part">
                                            <ul className="styled-icons icon-dark icon-theme-colored2 icon-sm icon-circled float-start mt-10">
                                                <li><Link className="social-link" to="#"><i className="fab fa-facebook"></i></Link></li>
                                                <li><Link className="social-link" to="#"><i className="fab fa-twitter"></i></Link></li>
                                                <li><Link className="social-link" to="#"><i className="fab fa-youtube"></i></Link></li>
                                            </ul>
                                            <Link className="btn btn-theme-colored2 btn-xs p-10 float-end" to="#">view details</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3">
                                <div className="staff-item mb-lg-40">
                                    <div className="staff-thumb"> <img alt="img" src="images/team/team7.jpg" className="w-100" />
                                    </div>
                                    <div className="staff-content">
                                        <h4 className="staff-name text-theme-colored1 mt-0">Andre Smith - <small>Teacher</small></h4>
                                        <p className="mb-20">Lorem ipsum dolor sit amet, con amit sectetur adipisicing elit.</p>
                                        <div className="staff-social-part">
                                            <ul className="styled-icons icon-dark icon-theme-colored2 icon-sm icon-circled float-start mt-10">
                                                <li><Link className="social-link" to="#"><i className="fab fa-facebook"></i></Link></li>
                                                <li><Link className="social-link" to="#"><i className="fab fa-twitter"></i></Link></li>
                                                <li><Link className="social-link" to="#"><i className="fab fa-youtube"></i></Link></li>
                                            </ul>
                                            <Link className="btn btn-theme-colored2 btn-xs p-10 float-end" to="#">view details</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3">
                                <div className="staff-item mb-sm-40">
                                    <div className="staff-thumb"> <img alt="img" src="images/team/team8.jpg" className="w-100" />
                                    </div>
                                    <div className="staff-content">
                                        <h4 className="staff-name text-theme-colored1 mt-0">Andre Smith - <small>Teacher</small></h4>
                                        <p className="mb-20">Lorem ipsum dolor sit amet, con amit sectetur adipisicing elit.</p>
                                        <div className="staff-social-part">
                                            <ul className="styled-icons icon-dark icon-theme-colored2 icon-sm icon-circled float-start mt-10">
                                                <li><Link className="social-link" to="#"><i className="fab fa-facebook"></i></Link></li>
                                                <li><Link className="social-link" to="#"><i className="fab fa-twitter"></i></Link></li>
                                                <li><Link className="social-link" to="#"><i className="fab fa-youtube"></i></Link></li>
                                            </ul>
                                            <Link className="btn btn-theme-colored2 btn-xs p-10 float-end" to="#">view details</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* <!-- Section: Job Apply Form --> */}
            <section className="divider parallax layer-overlay overlay-white-9" data-tm-bg-img="images/bg/news_result.webp" style={{ backgroundImage: `url('images/bg/news_result.webp')` }}>
                <div className="container-fluid py-5">
                    <div className="row justify-content-center">
                        <div className="col-md-12">
                            <h3 className="text-center text-theme-colored1 mb-20">Subscrice to
                                our Newsletter
                                & mailling list
                            </h3>

                        </div>
                        <div className="col-md-6 bg-lightest-transparent px-30 pb-0 pt-10">
                            <form method="post" onSubmit={submitForm}>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="mb-3">
                                            <label>Name <small>*</small></label>
                                            <input name="form_name" type="text" placeholder="Enter Name" className="form-control" value={nameValue} onChange={(e) => setNameValue(e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="mb-3">
                                            <label for="form_email">Email <small>*</small></label>
                                            <input name="form_email" className="form-control required email" type="email" placeholder="Enter Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <input name="form_botcheck" className="form-control" type="hidden" value="" />
                                        <button type="submit" className="btn btn-block btn-theme-colored1 mt-20 pt-10 pb-10" data-loading-text="Please wait...">Subscrice</button>
                                    </div>
                                </div>

                            </form>

                        </div>

                        <div className="col-sm-12 text-center">

                            <Modal   {...props}
                                size="lg"
                                style={customStyles}
                                aria-labelledby="contained-modal-title-vcenter"
                                centered show={show} onHide={handleClose} className="top-0 ">

                                <Modal.Header closeButton>
                                    <img className="" src='/images/cropped-9952-img-32x32.jpg' alt="" />

                                    <Modal.Title className='text-theme-colored2 fw-bold'>Subscrice to
                                        our Newsletter
                                        & mailling list</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <div className="team-member text-center">
                                        <div className="team-description pt-0">
                                            <h3><Link>{submitMsg}</Link></h3>
                                            <p className='lead fw-light'>{message}</p>
                                        </div>



                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Button className='btn btn-theme-colored2 btn-sm appoint-btn mt-3 mt-sm-0' variant="secondary" onClick={handleClose}>
                                        Close
                                    </Button>

                                </Modal.Footer>

                            </Modal>
                        </div>
                    </div>
                </div>
            </section>

            {/* <!-- Start Divider --> */}
            {/* <section className="clients bg-theme-color-2">
                <div className="container pt-10 pb-0">
                    <div className="row">
                        <div className="col-md-12">

                            <OwlCarousel
                                className="owl-carousel-6col clients-logo transparent text-center owl-nav-top"
                                items={6}
                                loop
                                autoplay
                                margin={30}
                                nav={false}
                                dots={false}
                                responsive={{
                                    0: { items: 1 },
                                    768: { items: 4 },
                                    1024: { items: 6 },
                                }}
                            >
                                <div className="item">
                                    <Link to="">
                                        <img src="/images/partners/partner_LOGOS-01.png" alt="" />
                                    </Link>
                                </div>
                                <div className="item">
                                    <Link to="">
                                        <img src="/images/partners/partner_LOGOS-02.png" alt="" />
                                    </Link>
                                </div>
                                <div className="item">
                                    <Link to="">
                                        <img src="/images/partners/partner_LOGOS-03.png" alt="" />
                                    </Link>
                                </div>
                                <div className="item">
                                    <Link to="">
                                        <img src="/images/partners/partner_LOGOS-04.png" alt="" />
                                    </Link>
                                </div>
                                <div className="item">
                                    <Link to="">
                                        <img src="/images/partners/partner_LOGOS-05.png" alt="" />
                                    </Link>
                                </div>
                                <div className="item">
                                    <Link to="">
                                        <img src="/images/partners/partner_LOGOS-06.png" alt="" />
                                    </Link>
                                </div>
                                <div className="item">
                                    <Link to="">
                                        <img src="/images/partners/partner_LOGOS-07.png" alt="" />
                                    </Link>
                                </div>

                            </OwlCarousel>
                        </div>
                    </div>
                </div>
            </section> */}
        </div>
        {/* <!-- end main-content --> */}
    </>
}
